import Enums from "../../../enums/enums";
export const mutations = {
  MutationSetForgotPwd(state) {
    state.setForgotPwdLoadingStatusType = Enums.LoadingStatusType.Success;
  },
  MutationGetForgotPwd(state, _forgotPwd) {
    state.forgotPwd = _forgotPwd;
    state.getForgotPwdLoadingStatusType = Enums.LoadingStatusType.Success;
  },
  MutationResetPwd(state) {
    state.resetPwdLoadingStatusType = Enums.LoadingStatusType.Success;
  },
};
